import { createContext } from 'react';

export const FixedSurfaceContext = createContext<boolean>(false);
